"use strict";
/**
 * Backup related socket events
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_RESTORE_COMPLETED = void 0;
/**
 * Event emitted when restore of a back is completed
 */
exports.EVENT_RESTORE_COMPLETED = "backup-restore-completed";
//# sourceMappingURL=backup-event.js.map